import { z } from 'zod'
import { oc } from '@orpc/contract'
import { actorOverrideSchema } from './assistant-conversation.contract'

export const assistantDelete = oc
  .route({ method: 'DELETE', path: '/v2/assistant/conversations/{convId}' })
  .input(z.object({ convId: z.string(), actor: actorOverrideSchema }))
  .output(z.object({ deleted: z.boolean(), blockedReason: z.literal('streaming').optional() }))
